import { AxiosPromise, AxiosResponse } from 'axios';

import { request } from '@cvt/clients/baseClient';
import { camelizeObject, snakizeObject } from '@cvt/helpers/object';

import { mapAssertionData, mapNextAssertionData } from './assertionClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const getAssertions = (params: Assertions.GetListParams): AxiosPromise<CVT.Query.PaginatedResults<Assertions.Assertion>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertions/`,
      method: 'GET',
      params: snakizeObject(params),
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Assertions.AssertionApi>>) => ({
    ...data,
    data: {
      ...camelizeObject(data.data),
      results: data.data.results.map(mapAssertionData),
    },
  }));
};

const getAssertion = (params: { id: number }): AxiosPromise<Assertions.Assertion> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertions/${params.id}/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Assertions.AssertionApi>) => ({
    ...data,
    data: mapAssertionData(data.data),
  }));
};

const getNextAssertion = (): AxiosPromise<Assertions.NextAssertion> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertions/next/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Assertions.NextAssertionApi>) => ({
    ...data,
    data: mapNextAssertionData(data.data),
  }));
};

const answerAssertion = (params: { id: number, answer: Assertions.AnswerValue }): AxiosPromise<Assertions.NextAssertion> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertions/${params.id}/answer/`,
      method: 'POST',
      data: {
        value: params.answer,
      },
    },
  }).then((data: AxiosResponse<Assertions.NextAssertionApi>) => ({
    ...data,
    data: mapNextAssertionData(data.data),
  }));
};


const getAssertionsResults = (): AxiosPromise<Assertions.AssertionResults> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertions/results/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Assertions.AssertionResultsApi>) => ({
    ...data,
    data: camelizeObject(data.data),
  }));
};

const getAssertionImages = (): AxiosPromise<CVT.Query.PaginatedResults<Assertions.AssertionImage>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertion-images/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<CVT.Query.PaginatedResults<Assertions.AssertionImageApi>>) => ({
    ...data,
    data: {
      ...camelizeObject(data.data),
      results: data.data.results,
    },
  }));
};

const getPreviousAssertion = (): AxiosPromise<Assertions.PreviousAssertion> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertions/previous/`,
      method: 'GET',
    },
  }).then((data: AxiosResponse<Assertions.PreviousAssertionApi>) => ({
    ...data,
    data: camelizeObject(data.data),
  }));
};

const calculateMatch = (): AxiosPromise<void> => {
  return request({
    options: {
      url: `${apiBaseUrl}/assertions/calculate/`,
      method: 'POST',
    },
  });
};

export const assertionClient = {
  getAssertions,
  getAssertion,
  getNextAssertion,
  answerAssertion,
  getAssertionsResults,
  getAssertionImages,
  getPreviousAssertion,
  calculateMatch,
};
